import { cn } from "@/lib/utils";

interface CalendarDragSelectionProps {
  startDay: number;
  endDay: number;
  headerHeight: number;
  rowHeight: number;
  width: number | string;
  leftOffset?: number;
}

export function CalendarDragSelection({
  startDay,
  endDay,
  headerHeight,
  rowHeight,
  width,
  leftOffset = 4,
}: CalendarDragSelectionProps) {
  const spanDays = endDay - startDay + 1;
  const topOffset = headerHeight + (startDay - 1) * rowHeight + 2;
  const height = spanDays * rowHeight - 4;

  return (
    <div
      className={cn(
        "absolute rounded pointer-events-none z-5",
        "bg-primary/20 border-2 border-primary border-dashed",
      )}
      style={{
        top: topOffset,
        left: leftOffset,
        width: width,
        height: height,
      }}
    />
  );
}
